import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal border-t border-gray-800 py-12" data-id="element-39">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-40">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-41">
          <div data-id="element-42">
            <div className="mb-4 bg-white inline-block p-3 rounded" data-id="element-43">
              <img src="https://cdn.magicpatterns.com/uploads/2Vc1SybtX5ntsou5rRY33H/NTY-Logo.png" alt="NTY Windows" className="h-14 w-auto" data-id="element-44" />
            </div>
            <p className="text-gray-400 text-sm" data-id="element-45">
              Building something better. Join us.
            </p>
          </div>

          <div data-id="element-46">
            <h4 className="text-white font-bold mb-3" data-id="element-47">Contact</h4>
            <div className="space-y-2 text-gray-400 text-sm" data-id="element-48">
              <p data-id="element-49">Missoula, MT</p>
              <p data-id="element-50">(800) 891-6882</p>
            </div>
          </div>

          <div data-id="element-51">
            <h4 className="text-white font-bold mb-3" data-id="element-52">Quick Links</h4>
            <div className="space-y-2" data-id="element-53">
              <a href="#" className="block text-gray-400 text-sm hover:text-maroon transition-colors" data-id="element-54">
                Home
              </a>
              <a href="#apply" className="block text-gray-400 text-sm hover:text-maroon transition-colors" data-id="element-55">
                Apply
              </a>
              <a href="#" className="block text-gray-400 text-sm hover:text-maroon transition-colors" data-id="element-56">
                Careers
              </a>
              <a href="#" className="block text-gray-400 text-sm hover:text-maroon transition-colors" data-id="element-57">
                Privacy Policy
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 text-center text-gray-500 text-sm" data-id="element-58">
          <p data-id="element-59">
            &copy; {new Date().getFullYear()} NTY Windows. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}